import React from 'react';
import {Tooltip} from '@mui/material';
import type {TooltipProps} from '@mui/material/Tooltip';
import type {DataSimpleValue} from 'schemaDefinition/types';
import {GhostIcon} from '../icons';
import {SuggestionsPreview} from './SuggestionsPreview';

type Props = Omit<TooltipProps, 'title' | 'children'> & {
  suggestions: DataSimpleValue[] | undefined;
};

export const SuggestionsTooltip: React.FC<Props> = ({suggestions, ...rest}) => {
  if (suggestions && suggestions.length > 0) {
    return (
      <Tooltip
        title={<SuggestionsPreview suggestions={suggestions} />}
        {...rest}>
        <GhostIcon />
      </Tooltip>
    );
  }
  return null;
};
